import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import HudModal from "./HudModal";
import { DEPARTMENTS, formatErr, inputCls, labelCls } from "../lib/constants";

const empty = { first_name: "", last_name: "", role: "", hotel_code: "", department_code: "" };

export default function PersonnelDialog({ open, person, hotels, defaults, onClose, onSaved }) {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setForm(person ? { ...empty, ...person } : { ...empty, ...defaults });
  }, [open, person, defaults]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const body = { first_name: form.first_name, last_name: form.last_name, role: form.role, hotel_code: form.hotel_code, department_code: form.department_code };
      if (person) await api.put(`/personnel/${person.id}`, body);
      else await api.post("/personnel", body);
      toast.success(person ? "Personel güncellendi" : "Personel eklendi");
      onSaved();
    } catch (err) {
      toast.error(formatErr(err));
    }
    setSaving(false);
  };

  return (
    <HudModal open={open} onClose={onClose} title={person ? `Personel Düzenle #${person.sira_no}` : "Yeni Personel"} testid="personnel-dialog">
      <form onSubmit={save} className="space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <div><label className={labelCls}>Ad</label><input data-testid="pf-first-name" required value={form.first_name} onChange={set("first_name")} className={inputCls} /></div>
          <div><label className={labelCls}>Soyad</label><input data-testid="pf-last-name" required value={form.last_name} onChange={set("last_name")} className={inputCls} /></div>
        </div>
        <div><label className={labelCls}>Görev</label><input data-testid="pf-role" required value={form.role} onChange={set("role")} className={inputCls} placeholder="Örn. Aşçı" /></div>
        <div><label className={labelCls}>Otel</label>
          <select data-testid="pf-hotel" required value={form.hotel_code} onChange={set("hotel_code")} className={inputCls}>
            <option value="">Seçin</option>
            {hotels.map((h) => <option key={h.code} value={h.code}>{h.name}</option>)}
          </select>
        </div>
        <div><label className={labelCls}>Departman</label>
          <select data-testid="pf-dept" required value={form.department_code} onChange={set("department_code")} className={inputCls}>
            <option value="">Seçin</option>
            {DEPARTMENTS.map((d) => <option key={d.code} value={d.code}>{d.name}</option>)}
          </select>
        </div>
        <button data-testid="pf-save" disabled={saving} className="w-full btn-cyan py-2.5 rounded-lg font-mono text-xs uppercase tracking-widest disabled:opacity-50">
          {saving ? "Kaydediliyor..." : "Kaydet"}
        </button>
      </form>
    </HudModal>
  );
}
